import React, {Component} from 'react';

class Stamp extends Component {
  render() {
    return (
      <section className="stamp">
        <div className="slds-media slds-media_center slds-media_responsive">
          <div className="slds-media__figure">
            <img src={"assets/step" + this.props.index + ".svg"} alt="" style={{width:'5rem'}} className="stamp-img" />
          </div>
          <div className="slds-media__body">
            <h3 className="slds-text-heading_medium slds-p-bottom_x-small text--blue text--bold">
              <span className="text--italic">Stamp {this.props.index}:</span> {this.props.heading}
            </h3>
            {this.props.children}
          </div>
        </div>
      </section>
    );
  }

}

export default Stamp;